export const style   = {
  main: {
    anchorOrigin: {
      horizontal: 'center',
      vertical: 'bottom',
    },
    sx: { width: 300 },
  },
  box: {
    sx: { my: 1 },
    fontSize: 'small',
    variant: 'body1',
  },
} as const;
